import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="min-h-[60vh] flex items-center justify-center px-6">
    <div className="text-center max-w-lg">
      <p className="text-sm uppercase tracking-[0.4em] text-muted-foreground">404</p>
      <h1 className="mt-4 text-3xl sm:text-4xl font-display font-semibold">Page Not Found</h1>
      <p className="mt-3 text-base text-muted-foreground">
        The page you are looking for doesn&apos;t exist or has moved.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center mt-6 px-6 py-3 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition"
      >
        Back to Home
      </Link>
    </div>
  </div>
);

export default NotFound;
